import {errorUserMessage} from "./actions";

import get from "lodash/get";
import {deleteUserMessage, displayUserMessage} from "./messagesSlice";
export const removeAfter = 5000;

export const userMessages = (store: any) => (next: any) => (action: any) => {
  const errorMessages = get(action, "error.userMessages");

  if (Array.isArray(errorMessages)) {
    errorMessages.forEach(m => {
      store.dispatch(errorUserMessage(m.message));
    });
  }

  if (action?.type === displayUserMessage.type) {
    if (Array.isArray(store?.getState?.()?.messages?.messages)) {
      const isDuplicate = store
        .getState()
        .messages.messages.some(
          message => message.message === action.payload.message && message.type === action.type
        );

      if (isDuplicate) {
        return;
      }
    }

    /**
     * The UX is more consistent if we show and dispose messages, otherwise they might re-appear when re-rendering
     */
    setTimeout(() => {
      store.dispatch(deleteUserMessage(action.payload));
    }, removeAfter);
  }

  next(action);
};
